import LogoIcon from '@/assets/icons/logo.svg';
import { WidgetLayout } from '@/modules/models/WidgetLayout';

import type { AnimationType } from './animations';

const animation = {
  container: {
    mobile: {
      open: 'slideUpIn' as AnimationType,
      close: 'slideUpOut' as AnimationType,
    },
    desktop: {
      open: 'slideUpIn' as AnimationType,
      close: 'slideUpOut' as AnimationType,
    },
  },
  bubble: {
    show: 'showMessage' as AnimationType,
  },
  widget: {
    default: {
      text: {
        open: 'fadeIn',
        close: 'fadeOut',
      },
    },
    side: {
      openWidget: 'slideRightIn' as AnimationType,
      closeButton: 'zoomIn' as AnimationType,
      background: {
        open: 'fadeIn',
        close: 'fadeOut',
      },
    },
  },
};

export const theme = {
  animation,
  global: {},
  colors: {
    light: '',
    dark: '',
  },
  fontFamily: 'Benton Sans',
  zIndexApp: 1000,
  mediaMobile: 'max-width: 768px',
  widget: {
    widgetLayout: WidgetLayout.DEFAULT,
    wrapper: {
      styles: {},
      mobile: {},
      desktop: {},
    },
    background: {
      title: {},
      tooltip: {},
    },
  },
  container: {
    mobile: {},
    desktop: {},
    styles: {},
  },
  messages: {
    mobile: {},
    desktop: {},
    styles: {},
  },
  header: {
    icon: LogoIcon,
    closeButton: {},
    mobile: {},
    desktop: {},
    styles: {},
  },
  prompts: {
    mobile: {},
    desktop: {},
    styles: {},
    item: {
      mobile: {},
      desktop: {},
      styles: {},
    },
  },
  chat: {},
  footer: {
    desktop: {},
    mobile: {},
    styles: {},
  },
  poweredBy: {
    desktop: {},
    mobile: {},
    styles: {},
  },
  bubble: {
    ml: {
      borderColor: '#C7C7C7',
      backgroundColor: '#FCFAF8',
      mobile: {},
    },
    user: {
      mobile: {},
    },
  },
  messageText: {
    ml: {
      color: '#000',
    },
    user: {
      color: '#000',
    },
  },
  appWrapper: {
    mobile: {
      open: {},
      close: {},
    },
    desktop: {
      open: {},
      close: {},
    },
  },
  outerWrapper: {
    mobile: {
      open: {},
      close: {},
    },
    desktop: {
      open: {},
      close: {},
    },
  },
  input: {
    desktop: {},
    mobile: {},
    styles: {},
  },
  sendButton: {
    desktop: {},
    mobile: {},
    styles: {},
  },
  singleChoice: {},
  singleChoiceButton: {},
  multiChoice: {},
  multiChoiceButton: {},
  maintenance: {
    groupButton: {
      styles: {},
      active: {},
    },
  },
};

export type ThemeType = typeof theme;
